import { createActionGroup, createReducer, createSelector, emptyProps, on, props } from '@ngrx/store';
import { ZagentMiniConfig, PENDING_PROJECT_ID } from '@zerops/zerops/core/zerops-services';

export const RECIPE_LIST_FEATURE_NAME = 'recipe-list-state';

// Re-export for backwards compatibility
export { PENDING_PROJECT_ID };

// Action Group
export const recipeListActions = createActionGroup({
  source: RECIPE_LIST_FEATURE_NAME,
  events: {
    'set Zagent Config': props<{ recipeSlug: string; environmentKey: string; config: ZagentMiniConfig }>(),
    'clear Zagent Config': props<{ recipeSlug: string; environmentKey: string }>(),
    'clear All Zagent Configs': emptyProps()
  }
});

// State Interface
export interface RecipeListState {
  // Map key format: `${recipeSlug}:${environmentKey}`
  zagentConfigMap: Record<string, ZagentMiniConfig>;
}

// Initial State
export const recipeListInitialState: RecipeListState = {
  zagentConfigMap: {}
};

// Reducer
export const recipeListReducer = createReducer(
  recipeListInitialState,

  on(recipeListActions.setZagentConfig, (state, { recipeSlug, environmentKey, config }) => ({
    ...state,
    zagentConfigMap: {
      ...state.zagentConfigMap,
      [`${recipeSlug}:${environmentKey}`]: config
    }
  })),

  on(recipeListActions.clearZagentConfig, (state, { recipeSlug, environmentKey }) => {
    const newMap = { ...state.zagentConfigMap };
    delete newMap[`${recipeSlug}:${environmentKey}`];
    return { ...state, zagentConfigMap: newMap };
  }),

  on(recipeListActions.clearAllZagentConfigs, () => recipeListInitialState)
);

// Selectors
export const selectRecipeListState = (state: any) => state[RECIPE_LIST_FEATURE_NAME] as RecipeListState;

export const selectZagentConfigMap = createSelector(
  selectRecipeListState,
  (state) => state?.zagentConfigMap ?? {}
);
